import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Navbar from '../navbar/Navbar';
import SidebarRight from '../sidebar/SidebarRight';
import GlobalMediaPlayer from '../player/GlobalMediaPlayer';
import FloatingMusicPlayer from '../player/FloatingMusicPlayer';
import MusicPlayerIndicator from '../player/MusicPlayerIndicator';
import { useThemeStore } from '../../stores/themeStore';
import PodcastAudioEngine from '../live/PodcastAudioEngine';
import { useEffect } from 'react';

/**
 * 🟢 MainLayout - REFACTORIZADO (v2)
 * 
 * CAMBIOS CLAVE:
 * 1. ❌ REMOVIDO: initSocket() / closeSocket()
 * 2. ✅ SIMPLIFICADO: Solo maneja ruteo y tema
 * 3. Socket se inicializa en SocketProvider (AppProviders)
 */
const MainLayout = () => {
  const location = useLocation();
  const hideSidebarRight = location.pathname.startsWith('/blogger');
  const theme = useThemeStore((state) => state.theme);

  useEffect(() => {
    if (theme === 'dark') {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
  }, [theme]);

  return (
    <div className="min-h-screen bg-gray-100 dark:bg-gray-900 transition-colors duration-300">
      <Navbar />
      <div className="flex max-w-7xl mx-auto pt-36 p-main-full px-2 sm:px-3 lg:px-4">
        <main className="flex-1 px-0">
          <Outlet />
        </main>
        {!hideSidebarRight && <SidebarRight />}
      </div>
      <GlobalMediaPlayer />
      <FloatingMusicPlayer />
      <MusicPlayerIndicator />
      <PodcastAudioEngine />
    </div>
  );
};

export default MainLayout;
